import { DynamicSelectOption } from './types';

const icelandPostalCodes = [
  { code: '000', city: 'Abroad' },
  { code: '101', city: 'Reykjavík' },
  { code: '102', city: 'Reykjavík' },
  { code: '103', city: 'Reykjavík' },
  { code: '104', city: 'Reykjavík' },
  { code: '105', city: 'Reykjavík' },
  { code: '107', city: 'Reykjavík' },
  { code: '108', city: 'Reykjavík' },
  { code: '109', city: 'Reykjavík' },
  { code: '110', city: 'Reykjavík' },
  { code: '111', city: 'Reykjavík' },
  { code: '112', city: 'Reykjavík' },
  { code: '113', city: 'Reykjavík' },
  { code: '116', city: 'Reykjavík' },
  { code: '121', city: 'Reykjavík' },
  { code: '123', city: 'Reykjavík' },
  { code: '124', city: 'Reykjavík' },
  { code: '125', city: 'Reykjavík' },
  { code: '127', city: 'Reykjavík' },
  { code: '128', city: 'Reykjavík' },
  { code: '129', city: 'Reykjavík' },
  { code: '130', city: 'Reykjavík' },
  { code: '132', city: 'Reykjavík' },
  { code: '161', city: 'Reykjavík' },
  { code: '162', city: 'Reykjavík' },
  { code: '170', city: 'Seltjarnarnes' },
  { code: '172', city: 'Seltjarnarnes' },
  { code: '190', city: 'Vogar' },
  { code: '191', city: 'Vogar' },
  { code: '200', city: 'Kópavogur' },
  { code: '201', city: 'Kópavogur' },
  { code: '202', city: 'Kópavogur' },
  { code: '203', city: 'Kópavogur' },
  { code: '206', city: 'Kópavogur' },
  { code: '210', city: 'Garðabær' },
  { code: '212', city: 'Garðabær' },
  { code: '220', city: 'Hafnarfjörður' },
  { code: '221', city: 'Hafnarfjörður' },
  { code: '222', city: 'Hafnarfjörður' },
  { code: '225', city: 'Álftanes' },
  { code: '230', city: 'Reykjanesbær' },
  { code: '232', city: 'Reykjanesbær' },
  { code: '233', city: 'Reykjanesbær' },
  { code: '235', city: 'Reykjanesbær' },
  { code: '240', city: 'Grindavík' },
  { code: '241', city: 'Grindavík' },
  { code: '245', city: 'Sandgerði' },
  { code: '246', city: 'Sandgerði' },
  { code: '250', city: 'Garður' },
  { code: '251', city: 'Garður' },
  { code: '260', city: 'Reykjanesbær' },
  { code: '262', city: 'Reykjanesbær' },
  { code: '270', city: 'Mosfellsbær' },
  { code: '271', city: 'Mosfellsbær' },
  { code: '276', city: 'Mosfellsbær' },
  { code: '300', city: 'Akranes' },
  { code: '301', city: 'Akranes' },
  { code: '302', city: 'Akranes' },
  { code: '310', city: 'Borgarnes' },
  { code: '311', city: 'Borgarnes' },
  { code: '320', city: 'Reykholt' },
  { code: '340', city: 'Stykkishólmur' },
  { code: '341', city: 'Stykkishólmur' },
  { code: '342', city: 'Stykkishólmur' },
  { code: '345', city: 'Flatey' },
  { code: '350', city: 'Grundarfjörður' },
  { code: '351', city: 'Grundarfjörður' },
  { code: '355', city: 'Ólafsvík' },
  { code: '356', city: 'Snæfellsbær' },
  { code: '360', city: 'Hellissandur' },
  { code: '370', city: 'Búðardalur' },
  { code: '371', city: 'Búðardalur' },
  { code: '380', city: 'Reykhólahreppur' },
  { code: '381', city: 'Reykhólahreppur' },
  { code: '400', city: 'Ísafjörður' },
  { code: '401', city: 'Ísafjörður' },
  { code: '410', city: 'Hnífsdalur' },
  { code: '415', city: 'Bolungarvík' },
  { code: '416', city: 'Bolungarvík' },
  { code: '420', city: 'Súðavík' },
  { code: '421', city: 'Súðavík' },
  { code: '425', city: 'Flateyri' },
  { code: '426', city: 'Flateyri' },
  { code: '430', city: 'Suðureyri' },
  { code: '431', city: 'Suðureyri' },
  { code: '450', city: 'Patreksfjörður' },
  { code: '451', city: 'Patreksfjörður' },
  { code: '460', city: 'Tálknafjörður' },
  { code: '461', city: 'Tálknafjörður' },
  { code: '465', city: 'Bíldudalur' },
  { code: '466', city: 'Bíldudalur' },
  { code: '470', city: 'Þingeyri' },
  { code: '471', city: 'Þingeyri' },
  { code: '500', city: 'Staður' },
  { code: '510', city: 'Hólmavík' },
  { code: '511', city: 'Hólmavík' },
  { code: '512', city: 'Hólmavík' },
  { code: '520', city: 'Drangsnes' },
  { code: '524', city: 'Árneshreppur' },
  { code: '530', city: 'Hvammstangi' },
  { code: '531', city: 'Hvammstangi' },
  { code: '540', city: 'Blönduós' },
  { code: '541', city: 'Blönduós' },
  { code: '545', city: 'Skagaströnd' },
  { code: '546', city: 'Skagaströnd' },
  { code: '550', city: 'Sauðárkrókur' },
  { code: '551', city: 'Sauðárkrókur' },
  { code: '560', city: 'Varmahlíð' },
  { code: '561', city: 'Varmahlíð' },
  { code: '565', city: 'Hofsós' },
  { code: '566', city: 'Hofsós' },
  { code: '570', city: 'Fljót' },
  { code: '580', city: 'Siglufjörður' },
  { code: '581', city: 'Siglufjörður' },
  { code: '600', city: 'Akureyri' },
  { code: '601', city: 'Akureyri' },
  { code: '602', city: 'Akureyri' },
  { code: '603', city: 'Akureyri' },
  { code: '604', city: 'Akureyri' },
  { code: '605', city: 'Akureyri' },
  { code: '606', city: 'Akureyri' },
  { code: '607', city: 'Akureyri' },
  { code: '610', city: 'Grenivík' },
  { code: '616', city: 'Grenivík' },
  { code: '611', city: 'Grímsey' },
  { code: '620', city: 'Dalvík' },
  { code: '621', city: 'Dalvík' },
  { code: '625', city: 'Ólafsfjörður' },
  { code: '626', city: 'Ólafsfjörður' },
  { code: '630', city: 'Hrísey' },
  { code: '640', city: 'Húsavík' },
  { code: '641', city: 'Húsavík' },
  { code: '645', city: 'Fosshóll' },
  { code: '650', city: 'Laugar' },
  { code: '660', city: 'Mývatn' },
  { code: '670', city: 'Kópasker' },
  { code: '671', city: 'Kópaskeri' },
  { code: '675', city: 'Raufarhöfn' },
  { code: '676', city: 'Raufarhöfn' },
  { code: '680', city: 'Þórshöfn' },
  { code: '681', city: 'Þórshöfn' },
  { code: '685', city: 'Bakkafjörður' },
  { code: '686', city: 'Bakkafjörður' },
  { code: '690', city: 'Vopnafjörður' },
  { code: '691', city: 'Vopnafjörður' },
  { code: '700', city: 'Fellabær og Egilsstaðir' },
  { code: '701', city: 'Egilsstaðir' },
  { code: '710', city: 'Seyðisfjörður' },
  { code: '711', city: 'Seyðisfjörður' },
  { code: '715', city: 'Mjóifjörður' },
  { code: '720', city: 'Borgarfjörður' },
  { code: '721', city: 'Borgarfjörður' },
  { code: '730', city: 'Reyðarfjörður' },
  { code: '731', city: 'Reyðarfjörður' },
  { code: '735', city: 'Eskifjörður' },
  { code: '736', city: 'Eskifjörður' },
  { code: '740', city: 'Neskaupstaður' },
  { code: '741', city: 'Neskaupstaður' },
  { code: '750', city: 'Fáskrúðsfjörður' },
  { code: '751', city: 'Fáskrúðsfjörður' },
  { code: '755', city: 'Stöðvarfjörður' },
  { code: '756', city: 'Stöðvarfjörður' },
  { code: '760', city: 'Breiðdalsvík' },
  { code: '761', city: 'Breiðdalsvík' },
  { code: '765', city: 'Djúpivogur' },
  { code: '766', city: 'Djúpivogur' },
  { code: '780', city: 'Höfn' },
  { code: '781', city: 'Höfn' },
  { code: '785', city: 'Öræfi' },
  { code: '800', city: 'Selfoss' },
  { code: '801', city: 'Selfoss' },
  { code: '802', city: 'Selfoss' },
  { code: '803', city: 'Selfoss' },
  { code: '804', city: 'Selfoss' },
  { code: '805', city: 'Selfoss' },
  { code: '806', city: 'Selfoss' },
  { code: '810', city: 'Hveragerði' },
  { code: '815', city: 'Þorlákshöfn' },
  { code: '816', city: 'Ölfus' },
  { code: '820', city: 'Eyrarbakki' },
  { code: '825', city: 'Stokkseyri' },
  { code: '840', city: 'Laugarvatn' },
  { code: '845', city: 'Flúðir' },
  { code: '846', city: 'Flúðir' },
  { code: '850', city: 'Hella' },
  { code: '851', city: 'Hella' },
  { code: '860', city: 'Hvolsvöllur' },
  { code: '861', city: 'Hvolsvöllur' },
  { code: '870', city: 'Vík' },
  { code: '871', city: 'Vík' },
  { code: '880', city: 'Kirkjubæjarklaustur' },
  { code: '881', city: 'Kirkjubæjarklaustur' },
  { code: '900', city: 'Vestmannaeyjar' },
  { code: '902', city: 'Vestmannaeyjar' },
];

const iceland_postal_codes = icelandPostalCodes.map((obj) => ({
  value: obj.code,
  label: `${obj.code}`,
}));

const iceland_postal_codes_long = icelandPostalCodes.map((obj) => ({
  value: obj.code,
  label: `${obj.code} ${obj.city}`,
}));

export const postal_code_to_city = (code: string) => {
  return icelandPostalCodes.find((obj) => obj.code === code)?.city ?? '';
};

export const postalCodeOptionsMap: Record<string, DynamicSelectOption[] | undefined> = {
  iceland_postal_codes,
  iceland_postal_codes_long,
};

export type PostalCodeOptionsKey = keyof typeof postalCodeOptionsMap;
